module.exports = __webpack_public_path__ + "images/emoji/open_mouth.40bacef1a634266a0f7d.png";